import { Alert as AlertMantine } from '@mantine/core'
import React, { memo } from 'react'

import { ReactComponent as InfoIcon } from '../../../icones/infoAmarelo.svg'

import * as S from './styles'

/** //* CRIA A TIPAGEM DA CONST types
 * @typedef {'default' | 'warning' | 'danger'} AlertType
 */

/**
 * @typedef {Object} AlertTypeProps
 * @property {JSX.Element} [icon]
 */

/** //* CRIA A TIPAGEM DO COMPONENTE
 * @typedef {Object} AlertProps
 * @property {AlertType} type
 * @property {string} [title]
 * @property {string} message
 * @property {string} [color]
 */

//* @type Define que a const abaixo vai ter essa tipagem Record<AlertType, AlertTypeProps>
//* (se mudar a posicao da const types sem colocar o  @type acima dela, nao vai funcionar o intellisense)
/**
 * @type {Record<AlertType, AlertTypeProps>}
 */

const types = {
  default: {},
  warning: {
    icon: <InfoIcon alt="info" src={InfoIcon} />
  },
  danger: {
    icon: <InfoIcon alt="info" src={InfoIcon} />
  }
}
//* @param Define que o componente vai receber essas props de AlertProps
/**
 * @param {AlertProps} props
 */

const Alert = ({ type, title, message, color }) => {
  const alertProp = types[type]

  return (
    <S.AlertWrapper type={type}>
      <AlertMantine title={title} color={color} {...alertProp}>
        {message}
      </AlertMantine>
    </S.AlertWrapper>
  )
}

export default memo(Alert)
